import api from '../api/paidit-api';
import {
    SET_ITEM_TO_CART,
    REMOVE_ITEM_FROM_CART,
    SET_ITEM_TO_CONSTRUCTION,
    FETCH_UPSELLS_DATA,
    SET_ORDER_TIP,
} from '../actions/types';
import checkoutService from '../services/checkout';

export const checkoutMiddleware = store => next => action => {
    if (action) {
        if (action.type === SET_ITEM_TO_CONSTRUCTION && !store.getState().order.itemInConstruction && action.payload) {
            getUpsells(store, 'onItemAdd', [action.payload.id]);
        }

        if (action.type === SET_ORDER_TIP) {
            setTimeout(checkoutService.validateCheckout, 100);
        }

        if (action.type === SET_ITEM_TO_CART || action.type === REMOVE_ITEM_FROM_CART) {
            setTimeout(() => {
                checkoutService.validateCheckout();

                getUpsells(store, 'onFinishOrder', store.getState().order.cart.items.map(i => i.id));
            }, 100);
        }
    }

    return next(action);
};

function getUpsells(store, type, itemsIds) {
    const branchId = store.getState().business.branch.id;
    const cartId = store.getState().order.cart.cartId;
    api({ rejectOnError: false, trackLoading: false, alertError: null }).order.getUpsells(branchId, type, { itemsInstancesIds: itemsIds }, cartId)
        .then(upsells => store.dispatch({ type: FETCH_UPSELLS_DATA, payload: upsells, meta: { trigger: type === 'onFinishOrder' ? -1 : itemsIds[0] } }));
}